// Firebase 설정 및 초기화
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase 설정
// Firebase 콘솔에서 프로젝트 설정 > 일반 > 앱 추가 > 웹 앱에서 복사
const firebaseConfig = {
  apiKey: "AIzaSyDRY95AJL0F5zeDWV3k-38cKyahCGBi9Xc",
  authDomain: "in-seomyeon.firebaseapp.com",
  projectId: "in-seomyeon",
  storageBucket: "in-seomyeon.firebasestorage.app",
  messagingSenderId: "209860057856",
  appId: "1:209860057856:web:3302806dd6417c0e9ff1e5",
  measurementId: "G-BL1D0JE9JQ"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

// Firebase 서비스 초기화
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;

